import { LANGUAGE_CODE } from '@healthhub/react-ui';
import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';

const TestPage = lazy(() => import('./pages/TestPage/TestPage'));

export const TEST_ROUTES = [
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <TestPage />,
    displayTitle: () => 'Test',
    pageType: PageType.PUBLIC,
    path: '/test',
    serviceCatalogCode: '',
  },
];
